import { fromJS } from 'immutable';
import ACTIONS from '../actions/types';

import validators from '../lib/validators';

function findByKey(key) {
  return function(entry) {
    return entry.get('key') === key;
  };
}

const State = {
  state: undefined,

  new: function(initialState) {
    this.state = initialState;
    return this;
  },

  checklistUseBullet: function(key, useBullet = true) {
    const idx = this.fieldIndex(key);
    if (this.state.getIn([idx, 'checklist'], false)) {
      const checklistIdx = this.fieldIndex(this.state.getIn([idx, 'checklist', 'key']));
      this.state = this.state.setIn([checklistIdx, 'useBullet'], useBullet);
    }
    return this;
  },

  clearValidations: function(key) {
    const idx = this.fieldIndex(key);
    if (this.state.getIn([idx, 'validations'], false)) {
      this.state = this.state.updateIn(['fields', idx, 'validations'], undefined, (v) => {
        if (typeof v === 'undefined') return;
        return fromJS(v.toJS().map((validation) => {
          return fromJS({ ...validation, passed: undefined, error: undefined });
        }));
      })
      .setIn([idx, 'props', 'valid'], undefined)
      .setIn([idx, 'props', 'error'], undefined);
    }
    return this;
  },

  fieldIndex: function(key) {
    return this.state.findIndex(findByKey(key));
  },

  setState: function(newState) {
    this.state = fromJS(newState);
    return this;
  },

  updateValue: function(key, value, valPath = ['value']) {
    const idx = this.fieldIndex(key);
    if (!(idx === -1)) { 
      const valuePath = fromJS(valPath).unshift(idx);
      this.state = this.state.setIn(valuePath, value);
    }
    return this;
  },

  validateChecklist: function(key, value) {
    const idx = this.fieldIndex(key);

    if (this.state.getIn([idx, 'checklist'], false)) {
      const checklistIdx = this.fieldIndex(this.state.getIn([idx, 'checklist', 'key']));
      const validations = validators.runChecklistValidations(this.state.getIn([idx, 'checklist', 'validations']).toJS(), value);

      this.checklistUseBullet(key);
      this.state = this.state.updateIn([checklistIdx, 'items'], undefined, (items) => {
        const newItems = items.toJS().map((item, itemIdx) => {
          return { ...item, valid: validations[itemIdx].passed };
        });
        return fromJS(newItems);
      });
    }
    return this;
  },

  validateField: function(key, value) {
    const idx = this.state.findIndex(findByKey(key));

    if (this.state.getIn([idx, 'validations'], false)) {
      const { valid, error, validations } = validators.runValidations(this.state.getIn([idx, 'validations']).toJS(), value, this.state.toJS());
      this.state = this.state.setIn([idx, 'validations'], fromJS(validations))
                  .setIn([idx, 'props', 'valid'], valid)
                  .setIn([idx, 'props', 'error'], error);
    }
    return this;
  },

  value: function() {
    return this.state;
  },
};

const defaultInitialState = fromJS([]);

function signup_fields(initialState = defaultInitialState) {
  return function(state = initialState, action) {
    switch (action.type) {
      case ACTIONS.FIELD_BLUR:
        return State.new(state)
          .validateField(action.field.key, action.field.value)
          .updateValue(action.field.key, action.field.value)
          .updateValue(action.linkTo.key, action.linkTo.value, ['props', 'value'])
          .checklistUseBullet(action.field.key, false)
          .value();
      case ACTIONS.FIELD_FOCUS:
        return State.new(state)
          .clearValidations(action.key)
          .checklistUseBullet(action.key, true)
          .value();
      case ACTIONS.PASSWORD_INPUT:
        return State.new(state)
          .validateChecklist(action.key, action.value)
          .updateValue(action.key, action.value)
          .value();
      case ACTIONS.SUBMIT_ERROR:
        return State.new(state)
          .setState(action.newState)
          .value();
      default:
        return state;
    }
  };
}

export default signup_fields;
